import React from "react";
import Marquee from "react-fast-marquee";
import { getBrandName } from "../common/brand";

const Announcement = ({ globalData }) => {
  const notices = globalData?.general?.notice || [];
  const brandName = getBrandName();
  const noticeItems =
    notices && notices.length > 0
      ? notices.filter(Boolean)
      : [`Welcome to ${brandName}`];

  return (
    <>
      <style>{`
       

        .rfm-child {
          transform: var(--transform); 
          display: flex;
        }

        .announcement-row {
          margin: 6px 8px 0 8px;
          gap: 10px;
          padding: 0 12px;
          overflow: hidden;
          background-color: var(--block);
          border: 1px var(--color) solid;
          height: 30px;
          color: var(--announcement-text);
          border-radius: 10px 0 10px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          width: 96%;
        }

        .announcement-left-icon {
          width: 24px;
          min-width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--announcement-left-icon);
          flex-shrink: 0;
        }

        .announcement-left-icon svg {
          width: 22px;
          height: 22px;
          display: block;
        }

        .announcement-marquee-wrap {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          display: flex;
          align-items: center;
        }

        .announcement-marquee-wrap .rfm-marquee-container {
          overflow: hidden;
        }

        .announcement-content {
          display: inline-flex;
          align-items: center;
        }

        .marquee-item {
          display: inline-flex;
          align-items: center;
          color: var(--announcement-marquee-text);
          font-size: 13px;
          font-weight: 500;
          line-height: 1;
          white-space: nowrap;
          letter-spacing: 0.1px;
        }

        .marquee-item::after {
          content: "•";
          color: var(--announcement-dot-separator);
          font-size: 10px;
          margin: 0 16px;
          line-height: 1;
        }

        .announcement-inline-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          color: var(--announcement-inline-icon);
          flex-shrink: 0;
        }

        .announcement-inline-icon svg {
          width: 16px;
          height: 16px;
          display: block;
        }

        .announcement-more {
          width: 28px;
          min-width: 28px;
          height: 28px;
          border: none;
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          flex-shrink: 0;
          padding: 0;
        }

        .announcement-more-dots {
          display: flex;
          align-items: center;
          gap: 3px;
        }

        .announcement-more-dots span {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: var(--announcement-more-dot);
          display: block;
          opacity: 0.95;
        }

        @media (max-width: 640px) {
          .announcement-row {
            margin: 0 8px;
            gap: 10px;
            padding: 0 12px;
            overflow: hidden;
            background-color: var(--block);
            border: 1px var(--color) solid;
            height: 30px;
            color: var(--announcement-text);
            border-radius: 10px 0 10px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            width: 96%;
          }

          .marquee-item {
            font-size: 12px;
          }

          .marquee-item::after {
            margin: 0 12px;
          }
        }
      `}</style>

      <div className="announcement-row">
        <span className="announcement-left-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M4 9.5V14.5H8L13.5 19V5L8 9.5H4Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M17 9C18.3333 10.2 18.3333 13.8 17 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M19.5 6.5C22.1667 9 22.1667 15 19.5 17.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </span>

        <div className="announcement-marquee-wrap">
          <Marquee speed={28} pauseOnHover pauseOnClick gradient={false}>
            <div className="announcement-content">
              {noticeItems.map((item, index) => (
                <div key={index} className="marquee-item">
                  {index === 0 && (
                    <span
                      className="announcement-inline-icon"
                      aria-hidden="true"
                    >
                      <svg viewBox="0 0 24 24" fill="none">
                        <path
                          d="M4 11V13C4 13.5523 4.44772 14 5 14H7L10 18V6L7 10H5C4.44772 10 4 10.4477 4 11Z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M14 10C15.2 10.8 15.2 13.2 14 14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>
                  )}
                  {item || `WELCOME TO ${brandName}`}
                </div>
              ))}
            </div>
          </Marquee>
        </div>

        <button type="button" className="announcement-more" aria-label="More">
          <span className="announcement-more-dots">
            <span />
            <span />
            <span />
          </span>
        </button>
      </div>
    </>
  );
};

export default Announcement;